import React from "react";

const LegalPage = ({ title, kicker, children }) => (
  <div data-testid={`legal-${kicker.toLowerCase().replace(/\s+/g, "-")}`}>
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-14">
        <p className="kicker">{kicker}</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl">{title}</h1>
      </div>
    </section>
    <section className="section">
      <div className="prose-td container-wide max-w-3xl space-y-4 text-foreground/85">{children}</div>
    </section>
  </div>
);

const Placeholder = () => (
  <p className="rounded-sm border border-dashed border-border bg-muted/50 p-4 text-sm text-muted-foreground">
    Full legal copy will be added by our team shortly. If you have any questions in the meantime, contact us at
    info@fastjunkpros.com.
  </p>
);

export const PrivacyPolicy = () => (
  <LegalPage kicker="Privacy" title="Privacy Policy">
    <p>
      We collect only what we need to give you a quote and coordinate your pickup: your name, phone, email,
      pickup address, photos of the items, and messages you send us.
    </p>
    <h2 className="font-display text-xl font-bold">Why we collect it</h2>
    <p>To quote your job, dispatch the right crew, follow up on service, and improve our platform.</p>
    <h2 className="font-display text-xl font-bold">Who we share it with</h2>
    <p>The independent local hauling crew assigned to your job, plus messaging and email providers we use to run the business.</p>
    <h2 className="font-display text-xl font-bold">Your choices</h2>
    <p>You can request access to, correction of, or deletion of your data at any time by contacting us.</p>
    <Placeholder />
  </LegalPage>
);

export const TermsOfService = () => (
  <LegalPage kicker="Terms" title="Terms of Service">
    <ul className="list-disc space-y-2 pl-6">
      <li>Quotes are based on the photos and details you provide.</li>
      <li>Final price can change if the job on-site is larger, heavier, or different than described.</li>
      <li>We may coordinate your job with an independent local hauling crew.</li>
      <li>You must disclose heavy, hazardous, or restricted items in advance.</li>
      <li>Same-day service is offered when possible but not guaranteed.</li>
      <li>Cancellations or no-shows may be subject to a fee.</li>
      <li>We are not responsible for undisclosed items, unsafe access, or property left behind after pickup.</li>
    </ul>
    <Placeholder />
  </LegalPage>
);

export const Disclaimer = () => (
  <LegalPage kicker="Disclaimer" title="Site Disclaimer">
    <p>
      Starting prices shown on this site are estimates only. Final pricing depends on location, load size,
      material type, stairs, distance, urgency, and disposal requirements.
    </p>
    <p>
      We work to connect customers with reliable local hauling partners. Availability may vary by location.
    </p>
    <Placeholder />
  </LegalPage>
);
